import {whiteColor, blueColor, oceanBlueColor, grayColor} from '../../cmsMainStyle'

const attachmentChipStyle = theme => ({
	attachmentLabel: {
		width: "100%",
		border: '1px solid',
		borderColor: grayColor[2],
		borderRadius: 3,
		background:	"linear-gradient(45deg, " + whiteColor + ", " + grayColor[1] + ")",
	},

	fileTypeImage: {
		width: "25px",
		height: "25px"
	},

	attachmentNameText: {
		fontSize: 14,
		fontWeight: 400,
		color: oceanBlueColor[12],
		// marginRight: theme.spacing(5),
	},

	attachmentSizeText: {
		fontSize: 12,
		color: grayColor[8],
		// marginRight: theme.spacing(0),
	},

	attachmentLabelBtn: {
		'&:hover': {
			color: blueColor[10]
		},
	}

	
})

export default attachmentChipStyle


